export const navItems = [
  { label: 'Home', link: '/home' },
  { label: 'About us', link: '/about' },
  { label: 'Our services', link: '/services' },
  { label: 'Impact', link: '/impact' },
  { label: 'Get involved', link: '/get-involved' },
  { label: 'Activities', link: '/activities' },
  { label: 'Contact us', link: '/contact' },
];
  